const layout = () => import('../../internal/dashboard/layoutV2.vue')

const buyCreditRandom = () => import('./buyCreditV2random.vue')

const buyPlanRoutes = {
  component: layout,
  children: [
    {
      path: '/buyPlan/random',
      name: 'buyPlanRandom',
      meta: {
        title: 'buyCreditRandom',
        requiresAuth: true,
      },
      component: buyCreditRandom,
    },
  ],
}

export default buyPlanRoutes
